import message from "../constants/message";

const formatMessage = (template, ...values) => {
    return values.reduce((formatted, value) => formatted.replace('%s', value), template);
};

// 半角英数字 + 一部記号
const alphaNumericSymbols = (str) => {
    return /^[a-zA-Z0-9_.-]{5,16}$/.test(str);
};

// 共通入力チェック
export function checkInput(text, minLength, maxLength, field) {
    if (!text.trim()) {
        return formatMessage(message.REQUIRED_MSG, field);
    }

    if (text.length < minLength) {
        return formatMessage(message.MIN_LENGTH_MSG, field, minLength);
    }
    if (text.length > maxLength) {
        return formatMessage(message.MAX_LENGTH_MSG, field, maxLength);
    }

    if (!alphaNumericSymbols(text)) {
        return formatMessage(message.ALPHA_NUMBERIC_SYMBOL_MSG, field);
    }

    return null;
}

/* =========================================================
 * 1) Login ID
 *    → required
 *    → format
 *    → max 50
 ========================================================= */
export const validateLoginId = (value) => {
    if (!value.trim()) {
        return formatMessage(message.REQUIRED_MSG, "ログインID");
    }

    if (value.length < 5) {
        return formatMessage(message.MIN_LENGTH_MSG, "ログインID", 5);
    }

    if (value.length > 50) {
        return formatMessage(message.MAX_LENGTH_MSG_TT, "ログインID", 50);
    }

    if (value.includes("@")) {
        const emailRegex =
            /^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9_%+-]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/

        if (!emailRegex.test(value)) {
            return "ログインID（メールアドレス）の形式が正しくありません。";
        }

        return "";
    }

    const loginIdRegex = /^[a-zA-Z0-9_.-]+$/;
    if (!loginIdRegex.test(value)) {
        return formatMessage(message.LOGIN_ID_INVALID_MSG, "ログインID");
    }

    return "";
};

/* =========================================================
 * 2) Password
 *    → checkInput(password, 8, 32)
 ========================================================= */
export const validatePassword = (value) => {
    return checkInput(value, 8, 32, "パスワード");
};

/* =========================================================
 * 3) User Name
 *    → only MAX 255
 ========================================================= */
export const validateName = (value) => {
    if (!value.trim()) {
        return formatMessage(message.REQUIRED_MSG, "ユーザー名");
    }

    if (value.length > 255) {
        return formatMessage(message.MAX_LENGTH_MSG_TT, "ユーザー名", 255);
    }

    return "";
};

/* =========================================================
 * 4) Email
 *    → required
 *    → format
 *    → max 50
 ========================================================= */
export const validateEmail = (value) => {
    if (!value.trim()) {
        return "メールアドレスを入力してください。";
    }

    const regex =
      /^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9_%+-]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/

    if (!regex.test(value)) {
        return "メールアドレスの形式が正しくありません。";
    }

    if (value.length > 50) {
        return formatMessage(message.MAX_LENGTH_MSG_TT, "メールアドレス", 50);
    }

    return "";
};